<script setup>
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import NavCard from "@/components/common/NavCard.vue";

const { t } = useI18n();
const router = useRouter();

const cards = [
	{
		key: 'logos',
		icon: 'imagesmode',
		title: "components.qrcode.index.logos.title",
		subtitle: "components.qrcode.index.logos.subtitle",
		routeName: '/qrcode/logos'
	},
	{
		key: 'categories',
		icon: 'category',
		title: "components.qrcode.index.categories.title",
		subtitle: "components.qrcode.index.categories.subtitle",
		routeName: '/qrcode/categories'
	},
	{
		key: 'campaigns',
		icon: 'campaign',
		title: "components.qrcode.index.campaigns.title",
		subtitle: "components.qrcode.index.campaigns.subtitle",
		routeName: '/qrcode/campaigns'
	},
	{
		key: 'urls',
		icon: 'link',
		title: "components.qrcode.index.urls.title",
		subtitle: "components.qrcode.index.urls.subtitle",
		routeName: '/qrcode/urls'
	},
];

function go(path){ router.push(path); }
</script>

<template>
	<v-card class="bg-white trezo-card  base-page-height">
		<NavCard :cards="cards" />
	</v-card>
</template>

<style scoped>
.card-name { background-color: #b5b5b536!important; }
.hover-elevate:hover { box-shadow: 0 6px 18px rgba(0,0,0,.08); }
</style>

